export const customNormalize = (input: string): string =>
	input
		.normalize('NFD')
		.replace(/\p{Diacritic}/gu, '')
		.replace(/\u0142/g, 'l');
